var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-card",
    [
      _c(
        "w-card-content",
        [
          _c(
            "w-row",
            [
              _c(
                "w-col",
                { staticClass: "inputs", attrs: { xs: "12" } },
                [
                  _c("app-info-input", {
                    attrs: {
                      value: _vm.value.VATPurchaseTradingGoods,
                      label: _vm.$ct("purchase-trading-goods"),
                    },
                  }),
                  _c("app-info-input", {
                    attrs: {
                      value: _vm.value.VATServicesAndCosts,
                      label: _vm.$ct("services-and-costs"),
                    },
                  }),
                  _c("app-info-input", {
                    attrs: {
                      value: _vm.value.VATBuisinessAssets,
                      label: _vm.$ct("buisiness-assets"),
                    },
                  }),
                  _c("app-info-input", {
                    attrs: {
                      value: _vm.value.VATAmountImportWithinTheEG,
                      label: _vm.$ct("amount-import-within-eg"),
                    },
                  }),
                  _c("app-info-input", {
                    attrs: {
                      value: _vm.value.VATAmountCoContracts,
                      label: _vm.$ct("amount-co-contracts"),
                    },
                  }),
                  _c("app-info-input", {
                    attrs: {
                      value: _vm.value.VATAmountServicesWithingTheEG,
                      label: _vm.$ct("amount-services-within-eg"),
                    },
                  }),
                ],
                1
              ),
              _c(
                "w-col",
                { attrs: { xs: "4" } },
                [
                  _c("app-info-input", {
                    attrs: {
                      value: _vm.subtractablePercent,
                      label: _vm.$ct("subtractable-percent"),
                    },
                  }),
                ],
                1
              ),
              _c(
                "w-col",
                { attrs: { xs: "8" } },
                [
                  _c("app-info-input", {
                    attrs: {
                      value: _vm.value.VATSubtractable,
                      label: _vm.$ct("subtractable"),
                    },
                  }),
                ],
                1
              ),
              _c(
                "w-col",
                { staticClass: "inputs", attrs: { xs: "12" } },
                [
                  _c("app-info-input", {
                    attrs: {
                      value: _vm.value.VATNotSubtractable,
                      label: _vm.$ct("not-subtractable"),
                    },
                  }),
                  _c("app-info-input", {
                    attrs: {
                      value: _vm.value.VATImportWithinTheEG,
                      label: _vm.$ct("import-within-eg"),
                    },
                  }),
                  _c("app-info-input", {
                    attrs: {
                      value: _vm.value.VATCoContracts,
                      label: _vm.$ct("co-contracts"),
                    },
                  }),
                  _c("app-info-input", {
                    attrs: {
                      value: _vm.value.VATImportOutsideTheEG,
                      label: _vm.$ct("import-outside-eg"),
                    },
                  }),
                ],
                1
              ),
              _c(
                "w-col",
                { staticClass: "inputs", attrs: { xs: "12" } },
                [
                  _c("app-info-input", {
                    attrs: {
                      value: _vm.value.Leeggoed,
                      label: _vm.$ct("leeggoed"),
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }